<div class="filters__row first">
  <div *ngFor="let filter of filters_options">
    <div *ngIf="filter.options.type === 1" [ngSwitch]="filter.options.type">
      <lib-text-filter
      #handlerRouter="routerListenChange"
      (changeData)="handlerRouter.performNavigation($event)"
      routerListenChange
      [routerParamsData]="{'intercept_name': filter.options.intercept_name, 'delay_time':filter.options.delay_time}"
      (changeData)="handlerRouter.performNavigation($event)"
      *ngSwitchCase="1" [defaultTextValue]="filter.options.defaultTextValue" [text_subject]="filter.options.text_subject"></lib-text-filter>
    </div>
  </div>
</div>
<div [class]="inner === false ? 'filters__row second' : ''">
  <div [class]="inner === false ?  'filters__filter' : ''">
    <div class="filter__category" *ngFor="let filter of filters_options">
      <div *ngIf="filter.options.type !== 1" [ngSwitch]="filter.options.type">
        <ng-container *ngIf="filter.options.hideFilter==null && (filter.options.options_subject|async)?.length > 0">
          <lib-combo
          #handlerRouter="routerListenChange"
          routerListenChange
          (changeData)="handlerRouter.performNavigation($event)"
          [routerParamsData]="{'intercept_name': filter.options.intercept_name, 'delay_time':filter.options.delay_time, 'only_on_init':filter.options.only_on_init}"
          *ngSwitchCase="2"
            [allConfig]="filter.options"
            [hide_callback_function]="filter.options.hide_callback_change"
            [hideElementsFunction]="filter.options.hideDataCallback"
            [initial_state]="filter.options.initial_state ? filter.options.initial_state : false"
            [name_filter]="filter.options.name_filter" [options_subject]="filter.options.options_subject"
            [option_name_property]="filter.options.option_name_property" [options_selected_subject]="filter.options.options_selected_subject"
            [attr.id]="filter.options.id"></lib-combo>
        </ng-container>

        <lib-date-filter
        #handlerRouter="routerListenChange"
        routerListenChange
        [min_date]="filter.options.min_date"
        [max_date]="filter.options.max_date"
        (changeData)="handlerRouter.performNavigation($event)"
        [routerParamsData]="{'intercept_name': filter.options.intercept_name, 'delay_time':filter.options.delay_time}"
        *ngSwitchCase="3" [id]="filter.options.id" [placeholder]="filter.options.placeholder"
          [dateFormControl]="filter.options.date_subject" [date_subject]="filter.options.date_subject" [format]="filter.options.date_format"></lib-date-filter>
        <lib-range-date-filter *ngSwitchCase="4" [id]="filter.options.id" [placeholder]="filter.options.placeholder"
          [dateFormControl]="filter.options.date_subject"

          [date_subject]="filter.options.date_subject" [format]="filter.options.date_format"></lib-range-date-filter>
        <lib-date-simple-range [hide]="filter.options.hideFilter" *ngSwitchCase="5" [option_from]="filter.options.date_from" [option_to]="filter.options.date_to"></lib-date-simple-range>
        <ng-container *ngIf="filter.options.hideFilter==null">
            <!--<app-combo-text-search-filter *ngSwitchCase="6"
              [name_filter]="filter.options.name_filter"
              [options_subject]="filter.options.options_subject"
              [option_name_property]="filter.options.option_name_property"
              [options_selected_subject]="filter.options.options_selected_subject"
              [groupProperty]="filter.options.groupProperty"
              [groupKey]="filter.options.groupKey"
              [id]="filter.options.id"></app-combo-text-search-filter>-->
          </ng-container>

        <ng-content class="inner-filter"></ng-content>

      </div>
    </div>
  </div>

</div>
